<template>
  <b-navbar style="background-color: #d5d5d5f7; height: 62px;" sticky>
    <b-navbar-brand to="/">
      <b-img :src="require('../assets/images/gmx_logo_2020.png')" 
        style="max-height: 30px;" 
        alt="Graphmetrix Logo" 
      />
    </b-navbar-brand>
    <b-nav-item-dropdown text="Lang">
      <b-dropdown-item href="#">EN</b-dropdown-item>
      <b-dropdown-item href="#">ES</b-dropdown-item>
      <b-dropdown-item href="#">RU</b-dropdown-item>
      <b-dropdown-item href="#">FA</b-dropdown-item>
    </b-nav-item-dropdown>

  </b-navbar>
</template>

<script>
export default {
  name: "gmxMainNavbar",
}
</script>